<template>
    <div class="field has-addons">
        <b-autocomplete ref="autocomplete" :value="value" @input="onInput" :data="data" v-bind="$attrs" @select="onSelect" :loading="loading" expanded>
        </b-autocomplete>
        <div class="control" v-if="clearable">
            <a class="button" @click="clear">Очистить</a>
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        value: {
            type:String,
            default:''
        },
        minlength: {
            type: Number,
            default: 1
        },
        noClear: {
            type: Boolean,
            default: false
        },
        endpoint: {
            type: String,
            default: '/'
        },
        method: {
            type: String,
            default: 'get'
        },
        params: {
            type: Object,
            default: () => { }
        },
    },
    data() {
        return {
            clearable: false,
            newValue: this.value,
            loading: false,
            selected: null,
            data: [],
        }
    },
    computed: {
        debouncedLoad: function() {
            return _.debounce(this.load, 500);
        },
    },
    methods: {
        clear: function(clearInput) {
            this.$refs.autocomplete.newValue = '';
            this.newValue = '';
            this.data = [];
            if (!this.noClear) {
                this.clearable = false;
                this.$refs.autocomplete.focus();
            }
            this.$emit('clear');
        },
        onInput: function(value) {
            value = _.trim(value);
            if (value.length == 0) {
                this.clear();
            } else if (!this.noClear) {
                this.clearable = true;
            }
            if (this.newValue !== value && value.length > this.minlength - 1) {
                this.newValue = value;
                this.debouncedLoad();
            }
            this.$emit('input', value)
        },
        onSelect: function(item) {
            this.selected = item;
            this.$emit('select', item);
        },
        load: function() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            let params = JSON.parse(JSON.stringify(this.params || {}));
            params = _.merge({
                name: _.trim(this.newValue)
            }, params);
            axios({
                method: this.method,
                url: this.endpoint,
                params: params
            }).then(({ data: result }) => {
                this.data = [];
                result.data.forEach((item) => {
                    this.data.push(item)
                });
                this.$emit('load', result);
                this.loading = false;
            }).catch(error => {
                this.loading = false;
            })
        }
    },
    mounted() {
        if (this.value.length) {
            this.clearable = true;
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ModelAutocomplete.vue